// import request from "@/utils/request";

import request from '@/utils/request';
let baseUrl = '/proxyapi';
/* 新闻列表 */
export function newslist(query) {
    return request({
       url: baseUrl+'/home/index/newslist',//接口地址
        method: 'get',
        params: query
    })
}
/*轮播图*/
export function bannerlist(query) {
    return request({
       url: baseUrl+'/home/index/swiper',//接口地址
        method: 'get',
        params: query
    })
}
// 紧急招聘
export function exigencelist(query) {
    return request({
       url: baseUrl+'/home/index/getUrgentRecruit',//接口地址
        method: 'get',
        params: query
    })
}
// 字典表接口
export function dictTypelist(dictType) {
    return request({
       url: baseUrl+'/home/index/dictType/'+dictType,//接口地址
        method: 'get',
    })
}
// 最新企业招聘
export function newjoblist(query) {
    return request({
       url: baseUrl+'/home/index/getNewestRecruit',//接口地址
        method: 'get',
        params: query
    })
}
// 最热企业招聘
export function hotjoblist(query) {
    return request({
       url: baseUrl+'/home/index/getHotRecruit',//接口地址
        method: 'get',
        params: query
    })
}
// 友情链接
export function linklist(query) {
    return request({
       url: baseUrl+'/home/index/getFriendLink',//接口地址
        method: 'get',
        params: query
    })
}
// 政府网站导航
export function friendlinklist(query) {
    return request({
       url: baseUrl+'/home/index/getGovFriendLink',//接口地址
        method: 'get',
        params: query
    })
}
// 查询分站
export function tenantInfolist(query) {
    return request({
       url: baseUrl+'/home/index/tenantInfo',//接口地址
        method: 'get',
        params: query
    })
}
// 用户协议

export function pact(query) {
    return request({
       url: baseUrl+'/home/auth/pact',//接口地址
        method: 'get',
        params: query
    })
}
// 职场指南
export function career(query) {
    return request({
       url: baseUrl+'/home/index/selList',//接口地址
        method: 'get',
        params: query
    })
}

//查询广告列表
export function advertList(query) {
    return request({
       url: baseUrl+'/home/index/getAdList',
        method: 'get',
        params: query
    })
}
// 推荐职位
export function getRecommendList(query) {
    return request({
       url: baseUrl+'/home/index/getRecommendRecruit',
        method: 'get',
        params: query
    })
}